const imgHomeMain = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingAiMain1 = "./assets/figma/111c9bf1-db26-4156-9910-1dd9cbae415b.png";
const img1 = "./assets/figma/17895adf-bae2-4edc-a3cc-7d725a15da27.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function HomeMain() {
  return (
    <div className="s0 s1" data-node-id="772:297" data-name="HOME_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s1068 s1" src={imgHomeMain} />
      </div>
      <p className="s106 s23 s2 s31 s1103 s1104 s107 s27 s1093 s1105 s115 s1106 s1107" data-node-id="772:298">
        DING AI LAB
      </p>
      <p className="s23 s2 s1108 s1109 s32 s1110 s27 s29 s1111 s1112 s54" data-node-id="772:304">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s2 s1113 s1114 s1115" data-node-id="886:3" data-name="DING_AI_MAIN 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingAiMain1} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="1035:596" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="1035:597">
          <div className="s111 s0 s28 s112" data-node-id="1035:598" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="1035:603">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="1035:604">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="1035:605">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:606">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:607">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <a className="s16 s141 s17 s24 s118 s18 s0 s28 s123" data-node-id="1035:608">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:609">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:610">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine26} />
            </div>
          </a>
          <a className="s16 s141 s17 s24 s118 s18 s0 s28 s124" data-node-id="1035:611">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:612">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:613">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}